"use strict";

angular.module('PatientApp').factory('LiveChatService', function ($q, $resource, endpoints) {
  var LiveChat = $resource(null, null, {
    postConversation: {
      method: 'POST',
      url: endpoints.liveChat.postConversation.url
    }
  });
  return {
    postConversation: function postConversation(conversationId) {
      return LiveChat.postConversation({
        'conversationId': conversationId
      }).$promise.then(function (resp) {
        if (resp && resp.hasData()) {
          return resp.getData();
        }

        return $q.reject(resp);
      });
    }
  };
});